import { toRegionalSpelling } from "./locale";
import type { RegionId } from "./regions";
import type {
  MetricKey,
  MetricLabels,
  WorkflowDefinition,
  WorkflowId,
} from "./types";

export const WORKFLOWS = [
  {
    id: "custom-sales",
    title: "Custom Sales & Quoting",
    description: "e.g., B2B Services",
    state: "A",
  },
  {
    id: "field-service",
    title: "Field Service & Dispatch",
    description: "e.g., IT Support, Facilities",
    state: "B",
  },
  {
    id: "high-volume",
    title: "High-Volume Staffing",
    description: "e.g., Healthcare, Temp Agencies",
    state: "C",
  },
  {
    id: "professional-services",
    title: "Professional Services & Reporting",
    description: "e.g., Consulting, Project Mgmt",
    state: "D",
  },
] as const satisfies readonly WorkflowDefinition[];

/** US-English metric labels (source of truth). */
export const METRIC_LABELS: Record<MetricKey, MetricLabels> = {
  labor: {
    short: "Labor Waste",
    report: "OpEx Labor Waste / Human-API Tax",
  },
  yieldPenalty: {
    short: "Yield Penalty",
    report: "Yield & Bottleneck Penalties",
  },
  untapped: {
    short: "Untapped Value",
    report: "Unharvested Database Value",
  },
};

/** Metric labels with UK/US spelling applied. */
export function getMetricLabels(
  regionId?: RegionId | null,
): Record<MetricKey, MetricLabels> {
  return {
    labor: {
      short: toRegionalSpelling(METRIC_LABELS.labor.short, regionId),
      report: toRegionalSpelling(METRIC_LABELS.labor.report, regionId),
    },
    yieldPenalty: METRIC_LABELS.yieldPenalty,
    untapped: METRIC_LABELS.untapped,
  };
}

const WORKFLOW_BY_ID: Record<WorkflowId, WorkflowDefinition> = {
  "custom-sales": {
    id: "custom-sales",
    title: "Custom Sales & Quoting",
    description: "e.g., B2B Services",
    state: "A",
  },
  "field-service": {
    id: "field-service",
    title: "Field Service & Dispatch",
    description: "e.g., IT Support, Facilities",
    state: "B",
  },
  "high-volume": {
    id: "high-volume",
    title: "High-Volume Staffing",
    description: "e.g., Healthcare, Temp Agencies",
    state: "C",
  },
  "professional-services": {
    id: "professional-services",
    title: "Professional Services & Reporting",
    description: "e.g., Consulting, Project Mgmt",
    state: "D",
  },
};

export function listWorkflows(): readonly WorkflowDefinition[] {
  return WORKFLOWS;
}

export function getWorkflow(id: WorkflowId): WorkflowDefinition {
  return WORKFLOW_BY_ID[id];
}

export function isWorkflowId(value: string): value is WorkflowId {
  return Object.hasOwn(WORKFLOW_BY_ID, value);
}
